// utils/speechRecognition.js
export const startListening = ({ onResult, onEnd }) => {
    console.log("Checking speech recognition support")
    const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
        alert("Oops! Your browser doesn't support voice recognition. Try using Chrome on a desktop or Android phone for full functionality.");
        return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        onResult(transcript);
    };

    recognition.onend = () => {
        onEnd?.();
    };

    recognition.start();
};
